import { Button, FormControl, TextField, useMediaQuery } from '@mui/material';
import { Container } from '@mui/system';
import React, { useRef } from 'react'
import emailjs from '@emailjs/browser';
import { useTheme } from '@emotion/react';
import { Store } from 'react-notifications-component';
import { toast } from 'react-hot-toast';

const Contact = () => {
    window.scrollTo(0, 0);
    const form = useRef();

    const theme = useTheme()

    const isXs= useMediaQuery(theme.breakpoints.down('xs'));
    const isSm= useMediaQuery(theme.breakpoints.down('sm'));
    const isMd= useMediaQuery(theme.breakpoints.down('md'));
    const isLg= useMediaQuery(theme.breakpoints.down('lg'));
    const isXl= useMediaQuery(theme.breakpoints.down('xl'));

    const emailRef = useRef()
    const nameRef = useRef()
    const messageRef = useRef()
  

    const sendEmail = (e) => {
      e.preventDefault();
      console.log("form.current", form.current)
      emailjs.sendForm('service_m5ad57o', 'template_gqnybah', form.current, 'UJc8A76WLXGzSRbnL')
        .then((result) => {
            console.log(result.text);
          nameRef.current.value=""
          emailRef.current.value=""
          messageRef.current.value=""
          toast.success("Your message has been sent")
        }, (error) => {
            console.log(error.text);
        });
    };

  const renderMobileContact = () => (
    <Container style={{ display: 'flex', flexDirection:'column', alignItems: 'center', marginTop: '200px', height: '100vh'}}>
      <h2>Contact</h2>
      <form ref={form} onSubmit={sendEmail} style={{display: 'flex', flexDirection:'column', width: '100%'}}>
      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField type="text" name="name" label="Name" margin="dense" inputRef={emailRef}/>
      </FormControl>
      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField type="email" name="email" label="Email" margin="dense" inputRef={nameRef}/>
      </FormControl>
      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField type="text" multiline rows={4} cols={2} name="message" label="Message" margin="dense" inputRef={messageRef}/>
      </FormControl>
      <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px'}}>
          <Button type="submit" variant="contained" value="Send" style={{width: '200px'}}>Send</Button>
      </div>
      </form>
    </Container>
  )

  const renderTabletContact = () => (
    <Container style={{ display: 'flex', flexDirection:'column', alignItems: 'center', marginTop: '200px', height: '100vh'}}>
      <h1>Contact</h1>
      <form ref={form} onSubmit={sendEmail} style={{display: 'flex', flexDirection:'column', width: '75%'}}>
      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField type="text" name="name" label="Name" margin="dense" inputRef={emailRef}/>
      </FormControl>
      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField type="email" name="email" label="Email" margin="dense" inputRef={nameRef}/>
      </FormControl>
      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField type="text" multiline rows={4} cols={2} name="message" label="Message" margin="dense" inputRef={messageRef}/>
      </FormControl>
      <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px'}}>
          <Button type="submit" variant="contained" value="Send" style={{width: '200px'}}>Send</Button>
      </div>
      </form>
    </Container>
  )
  
  const renderDesktopContact = () => (
    <Container style={{ display: 'flex', flexDirection:'column', alignItems: 'center', marginTop: '200px', height: '100vh'}}>
      <h1>Contact</h1>
      <form ref={form} onSubmit={sendEmail} style={{display: 'flex', maxWidth:'600px', flexDirection:'column', width: '100%'}}>
      <FormControl fullWidth style={{marginBottom: '10px'}}>
        <TextField type="text" name="name" label="Name" margin="dense" inputRef={emailRef}/>
      </FormControl>
      <FormControl fullWidth style={{marginBottom: '10px'}}>
        <TextField type="email" name="email" label="Email" margin="dense" inputRef={nameRef}/>
      </FormControl>
      <FormControl fullWidth style={{marginBottom: '10px'}}>
        <TextField type="text" multiline rows={4} cols={2} name="message" label="Message" margin="dense" inputRef={messageRef}/>
      </FormControl>
      <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px'}}>
          <Button type="submit" variant="contained" value="Send" style={{width: '200px'}}>Send</Button>
      </div>
      </form>
    </Container>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileContact() : 
        (isSm) ? renderMobileContact() :
        (isMd) ? renderTabletContact() :
        renderDesktopContact()
      }
    </div>
  )
}

export default Contact